import _ from "lodash";
import set from "@rill/set";
import React, { useState } from "react";
import submit from "submit-form";
import BackArrowButton from "../../../parts/back-arrow-button";
import SettingsNav from "../../../parts/settings-nav";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";

module.exports = (app) => {
  app
    .get(
      "/gym-contract",
      set("heading", "Edit Gym Contract"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      ({ res, locals }) => (res.body = <GymContract locals={locals} />)
    )

    .post(
      "/gym-contract",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body } = req;
        const { gymContract } = body;
        const { activeUser, organizationOwner } = locals;
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        const { pressCustomBranding = {} } = userToRequest;
        const newBody = {};

        newBody.pressCustomBranding = Object.assign({}, pressCustomBranding);
        newBody.pressCustomBranding.gymContract = gymContract;

        try {
          await api(`user/${userToRequest._id}`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", "Gym contract updated successfully.");
        } catch (e) {
          flash("error", e.message);
        }

        res.redirect("/coaching-portal/settings/gym-contract");
      }
    );
};

const GymContract = ({ locals }) => {
  const { activeUser, organizationOwner } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { pressCustomBranding } = userToRequest;
  const initialState =
    !!pressCustomBranding && !!pressCustomBranding.gymContract
      ? pressCustomBranding.gymContract
      : "";
  const [contractFormState, setContractFormState] = useState(initialState);

  /**
   * assign the value to the form
   * @param {*} param0
   */
  const handleInputChange = (event) => {
    const newState = event.target.value;
    setContractFormState(newState);
  };

  const handleDiscard = () => {
    setContractFormState(initialState);
  };

  return (
    <main className="settings gym-contract">
      <SettingsNav classNames="mobile-hidden" />

      <form
        id="form-gym-contract"
        method="POST"
        encType="multipart/form-data"
        data-noreset
      >
        <h3 className="mobile-hidden">Gym Contract</h3>
        <SettingsBackHandler title={"Gym Contract"} />

        <section>
          <div role="input-group">
            <label>Gym Contract</label>
            <textarea
              name="gymContract"
              placeholder="Enter your gym contract here"
              value={contractFormState}
              onChange={handleInputChange}
              sz="large"
            />
          </div>
        </section>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            type="button"
            onClick={handleDiscard}
          >
            Discard
          </button>
          <button data-button-type="primary" type="submit">
            Save
          </button>
        </footer>
      </form>
    </main>
  );
};
